export const getWeekFromDate = (fecha: Date): { lunes: Date; domingo: Date } => {
	// Crear una copia de la fecha para no modificar la original
	const fechaRef = new Date(fecha);
	
	// Obtener el día de la semana (0 = Domingo, 1 = Lunes, ..., 6 = Sábado)
	const diaSemana = fechaRef.getDay();
	
	// Calcular el lunes de esa semana usando getTime() para evitar problemas con setDate()
	const lunes = new Date(fechaRef);
	const diasHastaLunes = diaSemana === 0 ? 6 : diaSemana - 1;
	lunes.setTime(fechaRef.getTime() - (diasHastaLunes * 24 * 60 * 60 * 1000));
	lunes.setHours(0, 0, 0, 0);
	
	// Calcular el domingo de esa semana usando getTime() para evitar problemas con setDate()
	const domingo = new Date(fechaRef);
	const diasHastaDomingo = diaSemana === 0 ? 0 : 7 - diaSemana;
	domingo.setTime(fechaRef.getTime() + (diasHastaDomingo * 24 * 60 * 60 * 1000));
	domingo.setHours(23, 59, 59, 999);
	
	return {
		lunes,
		domingo
	};
};

export const getWeekDaysFromDate = (fecha: Date): Date[] => {
	const { lunes } = getWeekFromDate(fecha);
	const diasSemana: Date[] = [];
	
	for (let i = 0; i < 7; i++) {
		const dia = new Date(lunes);
		dia.setDate(lunes.getDate() + i);
		diasSemana.push(dia);
	}
	
	return diasSemana;
};

export const isDateInWeek = (fecha: Date, semana: { lunes: Date; domingo: Date }): boolean => {
	const fechaInicio = new Date(semana.lunes);
	fechaInicio.setHours(0, 0, 0, 0);
	
	const fechaFin = new Date(semana.domingo);
	fechaFin.setHours(23, 59, 59, 999);
	
	const fechaVerificar = new Date(fecha);
	fechaVerificar.setHours(0, 0, 0, 0);
	
	return fechaVerificar >= fechaInicio && fechaVerificar <= fechaFin;
};

export const formatDateToString = (fecha: Date): string => {
	const year = fecha.getFullYear();
	const month = String(fecha.getMonth() + 1).padStart(2, '0');
	const day = String(fecha.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
};

export const parseDateWithoutTimezone = (dateString: string): Date => {
	const [year, month, day] = dateString.split('-').map(Number)
	return new Date(year, month - 1, day) // month - 1 porque Date usa 0-based months
}

export const diaDeSemana = (fecha: Date): string => {
	const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
	return diasSemana[fecha.getDay()]
}

export const formatHourWithoutSeconds = (hour: string): string => {
	const [hours, minutes] = hour.split(':')
	return `${hours}:${minutes}`
}

export const formatStringToUserFullDate = (dateString: string): string => {
	const date = parseDateWithoutTimezone(dateString)
	return `${diaDeSemana(date)} ${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`
}

export const sumarMinutosAHora = (hora: string, minutos: number): string => {
	const [horas, minutosActuales] = hora.split(':').map(Number);
	const totalMinutos = horas * 60 + minutosActuales + minutos;
	const nuevaHora = Math.floor(totalMinutos / 60);
	const nuevoMinuto = totalMinutos % 60;
	
	// Manejar el caso donde se pasa de medianoche (puede ser > 24)
	const horaFinal = nuevaHora >= 24 ? nuevaHora % 24 : nuevaHora;
	
	return `${horaFinal.toString().padStart(2, '0')}:${nuevoMinuto.toString().padStart(2, '0')}`;
}

